import { render } from "./Title.vue?vue&type=template&id=f4b866e6&scoped=true"
import script from "./Title.vue?vue&type=script&setup=true&lang=js"
export * from "./Title.vue?vue&type=script&setup=true&lang=js"

import "./Title.vue?vue&type=style&index=0&id=f4b866e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b866e6"],['__file',"src/components/ui/Title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4b866e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4b866e6', __exports__)) {
    api.reload('f4b866e6', __exports__)
  }
  
  module.hot.accept("./Title.vue?vue&type=template&id=f4b866e6&scoped=true", () => {
    api.rerender('f4b866e6', render)
  })

}


export default __exports__